import React, { useEffect, useState } from 'react';
import Form from 'react-bootstrap/Form';
import 'toastr/build/toastr.min.css';
import { DisplayMessage } from '../../../../services/helpers.js';
import DelayedRedirect from '../../../../utils/DelayedRedirect';
import { Transition } from '../../../../utils/ModalHelpers';
import { Button, Link, FormControlLabel, Checkbox } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import Paper from '@material-ui/core/Paper';
import Dialog from '@material-ui/core/Dialog';
import AppBar from '@material-ui/core/AppBar';
import TextField from '@material-ui/core/TextField';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import { SelectTheme } from '../../../../utils/utils.js';
import { ThemeProvider } from "@material-ui/core";
import appFetch from '../../../../api/appFetch.js';
import { SnippetsWithIdUrl } from '../../../../constants/apiUrls.js';
import LanguageDropdown from '../../../Common/Dropdowns/LanguageDropdown.js';
import EnhancedDropdownComponent from '../../../Common/Dropdowns/EnhancedDropdownComponent.js';
import ModifiedByInfo from "./../../../Common/Footers/ModifiedByInfo";
import OutletsDropdown from '../../../Common/Dropdowns/OutletsDropdown.js';
import BrandsDropdown from '../../../Common/Dropdowns/BrandsDropdown.js';

const snippetTypes = Object.freeze({
    SnippetMediaFileNames: 5,
    SnippetPDFLibrary: 6
});

const SnippetEditing = (props) => {
    
    const { snippetId, language, resources, accessibleMoboOutlets, brands, objectType } = props;
    const [state, setState] = useState({
        id: snippetId === undefined ? 0 : snippetId,
        type: 0,
        language: language,
        title: "",
        content: "",
        isDefaultLocked: false,
        createdOn: "",
        createdByName: "",
        createdByAvatar: "",
        loading: snippetId !== undefined,
        requestInProgress: false,
        redirect: null,
        open: true,
        snippetWasCreated: false,
        brandId: 0,
        outletId: 0,
        accessibleMoboOutlets : accessibleMoboOutlets,
        objectType: objectType || null, 
        filteredBrands: brands || [] 
    });

    useEffect(() => {
        getData(state.id);
    }, [state.id]);

    const getData = (snippetId) => {
        setState(prevState => ({ ...prevState, requestInProgress: true }));

        appFetch({
            url: SnippetsWithIdUrl(snippetId),
            onSuccess: (data) => {

            const selectedOutlet = accessibleMoboOutlets?.find(outlet => 
                outlet.id === (data.outlet === null ? 0 : data.outlet.id)
            );
            const objectType = selectedOutlet ? selectedOutlet.objectType : state.objectType;
            const filteredBrands = filterBrandsByObjectType(objectType);

                setState(prevState => ({
                    ...prevState,
                    type: data.type,
                    language: data.language,
                    title: data.title,
                    content: data.content,
                    isDefaultLocked: data.isDefaultLocked,
                    brandId: data.brand === null ? 0 : data.brand.id,
                    outletId: data.outlet === null ? 0 : data.outlet.id,

                    createdOn: data.createdOn,
                    createdByName: data.createdBy.firstName + " " + data.createdBy.lastName,
                    createdByAvatar: data.createdBy.avatar,
                    fetchingData: false,
                    loading: false,
                    filteredBrands: filteredBrands
                }));
            },
            onError: (data) => {
                for (let i = 0; i < data.errors.length; i++) {
                    DisplayMessage(data.errors[i], "error");
                }
            },
            onFinalize: () => {
                setState(prevState => ({ ...prevState, requestInProgress: false }));
            }
        })
    }

    const handleClose = () => {
        setState(prevState => ({ ...prevState, open: false, redirect: "/snippets" }));
    };

    const handleChange = e => {
        if (e.target.name === "isDefaultLocked") {
            setState(prevState => ({ ...prevState, isDefaultLocked: e.target.checked }));
        }
        else { 
            setState(prevState => ({ ...prevState, [e.target.name]: e.target.value.replace(/^\s+/, "") })); 
        }

        checkIfRequestIsValid(false, state.typeValue);
    };

    const checkIfRequestIsValid = (displayErrorMessage, typeValue) => {
        var isValidRequest = true;

        if (state.title.trim().length <= 0) {
            if (displayErrorMessage) DisplayMessage(resources["InvalidTitle"], "error");
            isValidRequest = false;
        }

        if ((!state.content || state.content.trim().length <= 0) && state.type !== snippetTypes.SnippetMediaFileNames && state.type !== snippetTypes.SnippetPDFLibrary) {
            if (displayErrorMessage) DisplayMessage(resources["InvalidSnippet"], "error");
            isValidRequest = false;
        }

        if (typeValue === 0) {
            DisplayMessage(resources["InvalidType"], "error");
            return;
        }

        return isValidRequest;
    }

    const isValidForm = () => {
        if (!state.type || state.type === 0) {
            return false;
        }

        if (!state.title || state.title.trim().length === 0) {
            return false
        }

        if (!(state.type === 5 || state.type === 6)) {
            if (!state.content || state.content.trim().length === 0) {
                return false;
            }
        }

        return true;
    }

    const saveSnippet = () => {
        if (!checkIfRequestIsValid(true)) {
            return;
        }

        setState(prevState => ({ ...prevState, requestInProgress: true }));

        var newContent = state.content;
        if (state.type === snippetTypes.SnippetMediaFileNames || state.type === snippetTypes.SnippetPDFLibrary) {
            newContent = null;
        }

        const json = JSON.stringify({
            type: state.type,
            language: state.language,
            title: state.title,
            content: newContent,
            isDefaultLocked: state.isDefaultLocked,
            brandId: state.brandId === 0 ? null : state.brandId,
            outletId: state.outletId === 0 ? null : state.outletId
        });

        appFetch({
            url: SnippetsWithIdUrl(state.id),
            method: 'PUT',
            body: json,
            onSuccess: (data) => {
                DisplayMessage(resources["SnippetSuccessfullyEdited"], "success");
                setState(prevState => ({ ...prevState, snippetWasCreated: true, redirect: "/snippets" }));
            },
            onError: (data) => {
                for (var i = 0; i < data.errors.length; i++) {
                    DisplayMessage(data.errors[i], "error");
                }
            },
            onFinalize: () => {
                setState(prevState => ({ ...prevState, requestInProgress: false }));
            }
        })
    }

    // render created by
    const renderCreatedByInfo = () => {
        if (state.id > 0) {
            return (
                <ModifiedByInfo
                  resources={resources}
                  modifiedByAvatar={state.createdByAvatar}
                  modifiedOn={state.createdOn}
                  modifiedByName={state.createdByName}
                  className="mt-3"
                  isCreated={true}
                />
              );
        }
        return;
    }

    const handleChangeType = e => {
        setState(prevState => ({ ...prevState, type: parseInt(e.target.value), isDefaultLocked: false, file: undefined, base64file: "" }));
        checkIfRequestIsValid(false, parseInt(e.target.value));
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        event.stopPropagation();
        saveSnippet();
    };
    
    const handleChangeBrand = e => {
        setState(prevState => ({ ...prevState, brandId: parseInt(e.target.value) }));
    };

    const filterBrandsByObjectType = (objectType) => {
        if (!brands || !objectType) {
            return brands || [];
        }

        return brands.filter(brand => brand.objectType === objectType);
    };

    const handleChangeOutlet = e => {
       const selectedOutletId = parseInt(e.target.value);
        
        const selectedOutlet = accessibleMoboOutlets?.find(outlet => outlet.id === selectedOutletId);
        const objectType = selectedOutlet ? selectedOutlet.objectType : state.objectType;
       const filteredBrands = filterBrandsByObjectType(objectType);
        
        setState(prevState => ({ 
            ...prevState, 
            outletId: selectedOutletId,
            filteredBrands: filteredBrands,
            brandId: 0
        }));
    };

      useEffect(() => {
        if (brands) {
            const filteredBrands = filterBrandsByObjectType(state.objectType);
            setState(prevState => ({
                ...prevState,
                filteredBrands: filteredBrands
            }));
        }
    }, [brands]);

    const renderForm = () => {
        const { language, title, content, type, isDefaultLocked, brandId, outletId, accessibleMoboOutlets, filteredBrands } = state;
        var helperTextTitle = title.trim().length <= 0 ? "helper-text-red" : "helper-text-grey";
        var helperTextContent = !content || content.trim().length <= 0 ? "helper-text-red" : "helper-text-grey";

        return (
            <div>
                <Paper elevation={3} className="p-4 mt-3 mb-3">
                    <Form onSubmit={handleSubmit} >
                        <Form.Group className="d-flex">
                            <div className="col-3"></div>
                            <div className="col-6 helper-text-red" style={{ padding: 0 }}>
                                <EnhancedDropdownComponent
                                    id="type-dropdown"
                                    labelText={resources["Type"]}
                                    value={type}
                                    options={[
                                        { name: resources["SnippetExternalDossierChat"], key: 3 },
                                        { name: resources["SnippetInternalDossierChat"], key: 4 },
                                        { name: resources["SnippetMediaFileNames"], key: 5 },
                                        { name: resources["SnippetPDFLibrary"], key: 6 },
                                        { name: resources["SnippetSLA"], key: 7 }
                                    ].sort((a, b) => (a.name > b.name) ? 1 : -1)}
                                    placeholder={resources["SelectType"]}
                                    inputName="type"
                                    handleChange={handleChangeType}
                                    addMarginBottom={false}
                                    disabled
                                />
                            </div>
                            <div className="col-3"></div>
                        </Form.Group>

                        <Form.Group className="d-flex">
                            <div className="col-3"></div>
                            <LanguageDropdown
                                resources={resources}
                                language={language}
                                onLanguageChange={handleChange}
                                containerClass="col-6 helper-text-red"
                            />
                            <div className="col-3"></div>
                        </Form.Group>
                          <Form.Group className="d-flex">
                                                <div className="col-3"></div>
                                                <OutletsDropdown
                                                    resources={resources}
                                                    outlets={accessibleMoboOutlets}
                                                    outlet={outletId}
                                                    onOutletChange={handleChangeOutlet}
                                                    containerClass="col-6 helper-text-red"
                                                />
                                                <div className="col-3"></div>
                                            </Form.Group>
                        <Form.Group className="d-flex">
                            <div className="col-3"></div>
                                <BrandsDropdown
                                    resources={resources}
                                    brand={brandId}
                                    onBrandChange={handleChangeBrand}
                                    containerClass="col-6 helper-text-red"
                                    brands={filteredBrands}
                                    filteredByObjectType = {true} 
                                />
                            <div className="col-3"></div>
                        </Form.Group>
                        <Form.Group className="d-flex"  >
                            <div className="col-3"></div>
                            <ThemeProvider theme={SelectTheme}>
                                <TextField className={"col-6 " + helperTextTitle} id="snippet-title" value={title} label={resources["Title"]}
                                    helperText={resources["InputOfTitleIsMandatory"]}
                                    variant="outlined" name="title" onChange={handleChange} inputProps={{ maxLength: 100 }} />
                            </ThemeProvider >
                        </Form.Group>
                        <Form.Group className={type === snippetTypes.SnippetPDFLibrary ? "d-none" : "d-flex"} >
                            <div className="col-3"></div>
                            <ThemeProvider theme={SelectTheme}>
                                <TextField className={"col-6 " + helperTextContent} id="snippet-content" value={content} multiline minRows={4} label={resources["Snippet"]}
                                    helperText={resources["InputOfSnippetIsMandatory"]} autoComplete="off"
                                    variant="outlined" name="content" onChange={handleChange}
                                    disabled={type === snippetTypes.SnippetMediaFileNames} />
                            </ThemeProvider >
                        </Form.Group>
                        <Form.Group className={type !== snippetTypes.SnippetMediaFileNames && type !== snippetTypes.SnippetPDFLibrary ? "d-none" : "d-flex"} >
                            <div className="col-3 "> </div>
                            <ThemeProvider theme={SelectTheme}>
                                <FormControlLabel
                                    control={<Checkbox id="snippet-isDefaultLocked" checked={isDefaultLocked} onChange={handleChange} name="isDefaultLocked" color="primary" />}
                                    label={resources["IsDefaultLocked"]} />
                            </ThemeProvider>
                        </Form.Group>
                        <Form.Group className={type === snippetTypes.SnippetPDFLibrary ? "d-flex justify-content-center" : "d-none"}>
                            <ThemeProvider theme={SelectTheme}>
                                <Link href={content} title={resources["ViewPdfDocument"]} target='_blank'>
                                    {resources["ViewPdfDocument"]}
                                </Link>
                            </ThemeProvider>
                        </Form.Group>      
                        {renderCreatedByInfo()}
                    </Form>
                </Paper>

            </div >
        );
    }

    const renderMain = () => {
        const { loading } = state;

        if (loading) {
            return (<div className="centered-loader"><CircularProgress /></div>);
        }

        return <div className={"py-4 grey " + (state.loading ? 'fadeOut' : 'fadeIn')}>
            {renderForm()}
        </div>;
    }

    const { redirect, open, snippetWasCreated, outletId, requestInProgress } = state;

    const isSaveButtonDisabled = requestInProgress || !isValidForm() || redirect;

    return (
        <div>
            {redirect && <DelayedRedirect to={{ pathname: redirect, state: { refreshGrid: snippetWasCreated, outletId } }} delay={250} />}
            <Dialog fullScreen open={open} onClose={handleClose} TransitionComponent={Transition}>
                <AppBar className="position-sticky ">
                    <Toolbar>
                        <IconButton id="close-add-snippet" edge="start" color="inherit" onClick={handleClose} aria-label="close">
                            <CloseIcon />
                        </IconButton>
                        <Typography variant="h6" style={{ flex: 1 }}>
                            {resources["EditSnippetTitle"]}
                        </Typography>
                        <Button id="snippet-save" color="inherit" disabled={isSaveButtonDisabled} onClick={saveSnippet}>{resources["Save"]}</Button>
                    </Toolbar>
                </AppBar>
                <div className="container">
                    {renderMain()}
                </div>
            </Dialog>
        </div >
    );
}

export default SnippetEditing;